import React, { useEffect, useState } from "react";
import Navbar from "../../navbar/navbar";
import Footer from "../../footer/footer";
import Scroll from "./../../scrolltotop";
import Header from "./../projectoverview/overviewheader";
import Lightbox from "yet-another-react-lightbox";
import Thumbnails from "yet-another-react-lightbox/plugins/thumbnails";
import Captions from "yet-another-react-lightbox/plugins/captions";

import "yet-another-react-lightbox/styles.css";
import "yet-another-react-lightbox/plugins/thumbnails.css";
import "yet-another-react-lightbox/plugins/captions.css";

import Img1 from "./../../../assets/projects/terax/teraxactual (1).webp";
import Img2 from "./../../../assets/projects/terax/teraxactual (2).webp";
import Img3 from "./../../../assets/projects/terax/teraxactual (6).webp";
import Img4 from "./../../../assets/projects/terax/teraxactual (5).webp";
import Img5 from "./../../../assets/projects/terax/teraxactual (4).webp";
import Img6 from "./../../../assets/projects/terax/terax3d (1).webp";
import Img7 from "./../../../assets/projects/terax/teraxactual (8).webp";
import Img8 from "./../../../assets/projects/terax/teraxactual (9).webp";
import Img9 from "./../../../assets/projects/terax/terax3d (5).webp";
import Img10 from "./../../../assets/projects/terax/teraxactual (11).webp";
import Img11 from "./../../../assets/projects/terax/teraxactual (7).webp";
import Img12 from "./../../../assets/projects/terax/terax3d (2).webp";
import Img13 from "./../../../assets/projects/terax/terax3d (3).webp";
import Img14 from "./../../../assets/projects/terax/terax3d (4).webp";
import Img15 from "./../../../assets/projects/terax/teraxactual (10).webp";
import Img16 from "./../../../assets/projects/terax/terax3d (6).webp";
import Img17 from "./../../../assets/projects/terax/terax3d (7).webp";
import Img18 from "./../../../assets/projects/terax/terax3d (8).webp";
import Img19 from "./../../../assets/projects/terax/terax3d (9).webp";
import Img20 from "./../../../assets/projects/terax/terax3d (10).webp";
import Img21 from "./../../../assets/Industries/terex/maindining (1).webp";
import Img22 from "./../../../assets/Industries/terex/maindining (2).webp";
import Img24 from "./../../../assets/Industries/terex/maindining (3).webp";
import Img23 from "./../../../assets/Industries/terex/maindining (4).webp";
import Img25 from "./../../../assets/Industries/terex/maindining (5).webp";

const rawImages = [
  Img1, Img2, Img3, Img4, Img5, Img6, Img7, Img8, Img9,
  Img10, Img11, Img12, Img13, Img14, Img15, Img16, Img17, Img18, Img19, Img20, Img21, Img22, Img23, Img24, Img25
];

const images = rawImages.map((src, index) => ({
  src,
  alt: `Image ${index + 1}`,
  title: `Image ${index + 1} of 25`,
  // description: `This is image number ${index + 1}`, // Optional
}));

const ProjectImageGrid = () => {
  const [isMobile, setIsMobile] = useState(false);
  const [openIndex, setOpenIndex] = useState(-1);

  useEffect(() => {
    if (typeof window !== "undefined") {
      const handleResize = () => setIsMobile(window.innerWidth <= 768);
      window.addEventListener("resize", handleResize);
      handleResize();
      return () => window.removeEventListener("resize", handleResize);
    }
  }, []);

  return (
    <div>
      <Scroll />
      <Navbar />
      <Header />

      <div style={{ padding: "20px", marginTop: "50px" }}>
        <div
          style={{
            display: isMobile ? "flex" : "grid",
            flexDirection: isMobile ? "column" : "unset",
            gridTemplateColumns: isMobile ? "unset" : "repeat(auto-fit, minmax(300px, 1fr))",
            gridAutoRows: isMobile ? "unset" : "250px",
            gap: "10px",
            gridAutoFlow: "dense",
          }}
        >
          {rawImages.map((image, index) => (
            <div key={index} style={{ overflow: "hidden", borderRadius: "10px" }}>
              <img
                src={image}
                alt={`Project ${index + 1}`}
                style={{
                  width: "100%",
                  height: isMobile ? "auto" : "100%",
                  objectFit: "cover",
                  borderRadius: "10px",
                  transition: "transform 0.3s ease-in-out",
                  cursor: "pointer",
                }}
                onClick={() => setOpenIndex(index)}
                onMouseOver={(e) => (e.currentTarget.style.transform = "scale(1.05)")}
                onMouseOut={(e) => (e.currentTarget.style.transform = "scale(1)")}
              />
            </div>
          ))}
        </div>
      </div>

      <Lightbox
        open={openIndex >= 0}
        index={openIndex}
        close={() => setOpenIndex(-1)}
        slides={images}
        plugins={[Thumbnails, Captions]} // <-- 👈 Add plugins here
      />
{/* Inline style override for caption container */}
<style>
        {`
          .yarl__slide_captions_container {
            background: transparent !important;
          }

           .yarl__container {
      background-color:rgba(0, 0, 0, 0.9)  !important; /* Dark grey */
    }
        `}
      </style>

      <Footer />
    </div>
  );
};

export default ProjectImageGrid;